var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgRewind = function SvgRewind(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "rewind_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#rewind_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.528 16.087 13.375 12l6.153-4.087v8.174ZM12.5 13.199l6.98 4.636c.652.434 1.52-.04 1.52-.829V6.994c0-.79-.868-1.263-1.52-.83l-6.98 4.637V6.994c0-.79-.868-1.263-1.52-.83l-7.538 5.007a.998.998 0 0 0 0 1.658l7.537 5.006c.653.434 1.521-.04 1.521-.829V13.2Zm-1.472 2.888L4.875 12l6.153-4.087v8.174Z",
    fill: "currentColor"
  }))));
};
export default SvgRewind;